import React from "react";

export const DownloadButton = ({ property }) => {
  const value = property.get();
  if (value == null) {
    return null;
  }
  return (
    <a
      className="download button rounded"
      title="download"
      href={value}
      download={value.substringAfterLast("/")}
    >
      ▼
    </a>
  );
};
